/* ==========================================================================
   Search Drawer - Predictive Search
   Figma: Rossi Boots - Theme Reskin
   Desktop: node 11796:46261 | No Results: node 11796:46048
   ========================================================================== */

(function () {
  'use strict';

  var drawer = document.getElementById('Drawer-Search');
  if (!drawer) return;

  var input = drawer.querySelector('[data-search-input]');
  var clearBtn = drawer.querySelector('[data-search-clear]');
  var defaultState = drawer.querySelector('[data-search-default]');
  var resultsState = drawer.querySelector('[data-search-results]');
  var noResultsState = drawer.querySelector('[data-search-no-results]');
  var noResultsText = drawer.querySelector('[data-search-no-results-text]');
  var loadingState = drawer.querySelector('[data-search-loading]');
  var suggestionsContainer = drawer.querySelector('[data-search-suggestions]');
  var productsContainer = drawer.querySelector('[data-search-products]');
  var footer = drawer.querySelector('[data-search-footer]');
  var viewLink = drawer.querySelector('[data-search-view-link]');
  var searchTerms = drawer.querySelectorAll('[data-search-term]');
  var noResultsPopular = drawer.querySelector('[data-search-no-results-popular]');
  var noResultsTerms = drawer.querySelector('[data-search-no-results-terms]');

  var debounceTimer = null;
  var abortController = null;
  var currentQuery = '';
  var popularSearchesFetched = false;

  /* --- Money formatting --- */
  function formatMoney(priceValue) {
    var format = (window.FoxThemeSettings && window.FoxThemeSettings.money_format) || '${{amount}}';
    /* Shopify predictive search returns price as a decimal string in the shop's currency (e.g. "219.00"), not cents */
    var dollars = typeof priceValue === 'string' ? parseFloat(priceValue) : priceValue;
    if (isNaN(dollars)) return '';
    var amount = dollars.toFixed(2);
    var amountNoDecimals = Math.floor(dollars).toString();
    var amountWithComma = amount.replace('.', ',');

    return format
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1.'))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  /* --- State management --- */
  function showState(stateName) {
    var states = [defaultState, resultsState, noResultsState, loadingState];
    states.forEach(function (el) {
      if (el) el.hidden = true;
    });

    switch (stateName) {
      case 'default':
        if (defaultState) defaultState.hidden = false;
        break;
      case 'results':
        if (resultsState) resultsState.hidden = false;
        break;
      case 'no-results':
        if (noResultsState) noResultsState.hidden = false;
        break;
      case 'loading':
        if (loadingState) loadingState.hidden = false;
        break;
    }
  }

  function updateClearButton() {
    if (!clearBtn) return;
    var hasQuery = input && input.value.trim().length > 0;
    clearBtn.hidden = !hasQuery;
  }

  function showFooter(productCount, query) {
    if (!footer || !viewLink) return;
    if (productCount > 0 && query) {
      var rootUrl = (window.FoxThemeSettings && window.FoxThemeSettings.routes && window.FoxThemeSettings.routes.root) || '/';
      var searchUrl = rootUrl + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
      viewLink.href = searchUrl;
      viewLink.textContent = 'View results';
      footer.hidden = false;

      /* Fetch total count via section rendering */
      fetch(rootUrl + 'search?q=' + encodeURIComponent(query) + '&type=product&section_id=search-count')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var countEl = doc.querySelector('[data-search-total-count]');
          if (countEl) {
            var count = parseInt(countEl.textContent.trim(), 10);
            if (!isNaN(count) && count > 0) {
              viewLink.textContent = 'View ' + count + ' results';
            }
          }
        })
        .catch(function () { /* keep "View results" */ });
    } else {
      footer.hidden = true;
    }
  }

  function hideFooter() {
    if (footer) footer.hidden = true;
  }

  /* --- Render results --- */
  function renderSuggestions(queries) {
    if (!suggestionsContainer) return;
    suggestionsContainer.innerHTML = '';

    if (!queries || queries.length === 0) {
      suggestionsContainer.closest('.search-drawer__section').hidden = true;
      var divider = suggestionsContainer.closest('.search-drawer__section').nextElementSibling;
      if (divider && divider.classList.contains('search-drawer__divider')) {
        divider.hidden = true;
      }
      return;
    }

    suggestionsContainer.closest('.search-drawer__section').hidden = false;
    var divider = suggestionsContainer.closest('.search-drawer__section').nextElementSibling;
    if (divider && divider.classList.contains('search-drawer__divider')) {
      divider.hidden = false;
    }

    queries.forEach(function (query) {
      var a = document.createElement('a');
      a.href = query.url;
      a.className = 'btn--text btn--text--md';
      var label = document.createElement('span');
      label.className = 'btn--text__label';
      label.textContent = query.text;
      a.appendChild(label);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (input) {
          input.value = query.text;
          performSearch(query.text);
        }
      });
      suggestionsContainer.appendChild(a);
    });
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    /* Handle Shopify CDN image URLs - add size parameter */
    if (url.indexOf('cdn.shopify.com') !== -1) {
      var match = url.match(/(.+)\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
      if (match) {
        return match[1] + '_' + size + 'x.' + match[2] + (match[3] || '');
      }
    }
    return url;
  }

  function renderProducts(products) {
    if (!productsContainer) return;
    productsContainer.innerHTML = '';

    products.forEach(function (product) {
      var a = document.createElement('a');
      a.href = product.url;
      a.className = 'search-drawer__product-card';

      if (product.image) {
        var imgDiv = document.createElement('div');
        imgDiv.className = 'search-drawer__product-image';
        var img = document.createElement('img');
        img.src = getSizedImageUrl(product.image, '234');
        img.alt = product.title || '';
        img.width = 117;
        img.height = 117;
        img.loading = 'lazy';
        imgDiv.appendChild(img);
        a.appendChild(imgDiv);
      }
      var detailsDiv = document.createElement('div');
      detailsDiv.className = 'search-drawer__product-details';
      var titleP = document.createElement('p');
      titleP.className = 'search-drawer__product-title';
      titleP.textContent = product.title;
      detailsDiv.appendChild(titleP);
      var priceP = document.createElement('p');
      priceP.className = 'search-drawer__product-price';
      var price = product.price_min || product.price || 0;
      priceP.innerHTML = formatMoney(price);
      detailsDiv.appendChild(priceP);
      a.appendChild(detailsDiv);
      productsContainer.appendChild(a);
    });
  }

  /* --- Populate no-results popular searches --- */
  function ensurePopularSearches() {
    if (!noResultsTerms || popularSearchesFetched) return;
    /* If server-rendered terms already exist, nothing to do */
    if (noResultsTerms.children.length > 0) return;

    /* Copy terms from the default state if available */
    var defaultTerms = defaultState ? defaultState.querySelectorAll('[data-search-term]') : [];
    if (defaultTerms.length > 0) {
      defaultTerms.forEach(function (term) {
        var clone = term.cloneNode(true);
        clone.addEventListener('click', function (e) {
          e.preventDefault();
          var text = clone.textContent.trim();
          if (input) {
            input.value = text;
            performSearch(text);
          }
        });
        noResultsTerms.appendChild(clone);
      });
      popularSearchesFetched = true;
      return;
    }

    /* Fallback: fetch popular queries from the suggest API */
    popularSearchesFetched = true;
    var rootUrl = (window.FoxThemeSettings && window.FoxThemeSettings.routes && window.FoxThemeSettings.routes.root) || '/';
    fetch(rootUrl + 'search/suggest.json?q=*&resources[type]=query&resources[limit]=5')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var queries = data.resources && data.resources.results && data.resources.results.queries;
        if (!queries || queries.length === 0) {
          /* Hide the section if no popular searches available */
          if (noResultsPopular) noResultsPopular.hidden = true;
          return;
        }
        queries.forEach(function (q) {
          var a = document.createElement('a');
          a.href = q.url;
          a.className = 'btn--text btn--text--md';
          var label = document.createElement('span');
          label.className = 'btn--text__label';
          label.textContent = q.text;
          a.appendChild(label);
          a.addEventListener('click', function (e) {
            e.preventDefault();
            if (input) {
              input.value = q.text;
              performSearch(q.text);
            }
          });
          noResultsTerms.appendChild(a);
        });
      })
      .catch(function () {
        if (noResultsPopular) noResultsPopular.hidden = true;
      });
  }

  /* --- Predictive search API --- */
  function performSearch(query) {
    query = query.trim();
    currentQuery = query;

    if (!query) {
      showState('default');
      hideFooter();
      updateClearButton();
      return;
    }

    updateClearButton();
    showState('loading');

    if (abortController) abortController.abort();
    abortController = new AbortController();

    var rootUrl = (window.FoxThemeSettings && window.FoxThemeSettings.routes && window.FoxThemeSettings.routes.root) || '/';
    var url = rootUrl + 'search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product,query'
      + '&resources[limit]=6'
      + '&resources[options][fields]=title,product_type,variants.title';

    fetch(url, { signal: abortController.signal })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var resources = data.resources && data.resources.results;
        if (!resources) {
          showState('no-results');
          if (noResultsText) {
            noResultsText.textContent = 'No results found for "' + query + '". Check the spelling or use a different word or phrase.';
          }
          ensurePopularSearches();
          hideFooter();
          return;
        }

        var products = resources.products || [];
        var queries = resources.queries || [];

        if (products.length === 0 && queries.length === 0) {
          showState('no-results');
          if (noResultsText) {
            noResultsText.textContent = 'No results found for "' + query + '". Check the spelling or use a different word or phrase.';
          }
          ensurePopularSearches();
          hideFooter();
          return;
        }

        renderSuggestions(queries);
        renderProducts(products);
        showState('results');

        showFooter(products.length, query);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        showState('default');
        hideFooter();
      });
  }

  /* --- Event listeners --- */
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      updateClearButton();

      if (!query) {
        if (abortController) abortController.abort();
        showState('default');
        hideFooter();
        return;
      }

      debounceTimer = setTimeout(function () {
        performSearch(query);
      }, 300);
    });

    /* Submit the form to go to search results page */
    var form = input.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        /* Let the form submit normally */
      });
    }
  }

  /* Clear button */
  if (clearBtn && input) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      if (abortController) abortController.abort();
      showState('default');
      hideFooter();
      updateClearButton();
      input.focus();
    });
  }

  /* Search term clicks */
  searchTerms.forEach(function (term) {
    term.addEventListener('click', function (e) {
      e.preventDefault();
      var text = term.textContent.trim();
      if (input) {
        input.value = text;
        performSearch(text);
      }
    });
  });

  /* Close drawer helper */
  function closeSearchDrawer() {
    drawer.classList.remove('is-open');
    var overlay = document.querySelector('[data-header-drawer-overlay="Drawer-Search"]');
    if (overlay) overlay.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    /* Restore focus to trigger */
    var trigger = document.querySelector('[data-header-open-drawer="Drawer-Search"]');
    if (trigger) trigger.focus();
  }

  /* Bind close button (in case header JS hasn't bound it yet) */
  var closeBtn = drawer.querySelector('[data-header-close-drawer="Drawer-Search"]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeSearchDrawer();
    });
  }

  /* Close on overlay click */
  var overlay = document.querySelector('[data-header-drawer-overlay="Drawer-Search"]');
  if (overlay) {
    overlay.addEventListener('click', function () {
      closeSearchDrawer();
    });
  }

  /* Focus input when drawer opens */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'class') {
        if (drawer.classList.contains('is-open')) {
          setTimeout(function () {
            if (input) input.focus();
          }, 350);
        } else {
          /* Reset state when drawer closes */
          if (input) input.value = '';
          showState('default');
          hideFooter();
          updateClearButton();
        }
      }
    });
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  /* Close on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!drawer.classList.contains('is-open')) return;
    closeSearchDrawer();
  });
})();
